import { fetchError, fetchStart, fetchSuccess } from '../../../redux/actions';
import { setAuthUser, setForgetPassMailSent, setMFA, updateLoadUser } from '../../../redux/actions/Auth';
import React, { useContext } from 'react';
import axios from './config';
import { flags, languageData } from '../../../@jumbo/components/AppLayout/partials/LanguageSwitcher/data.js';
import AppContext from '../../../@jumbo/components/contextProvider/AppContextProvider/AppContext.js';

const JWTAuth = {
  onRegister: ({ name, email, password }) => {
    return dispatch => {
      dispatch(fetchStart());
      axios
        .post('', {
          email: email,
          password: password,
          name: name,
        })
        .then(({ data }) => {
          if (data.result) {
            localStorage.setItem('token', data.token.access_token);
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token.access_token;
            dispatch(fetchSuccess());
            dispatch(JWTAuth.getAuthUser(true, data.token.access_token));
          } else {
            dispatch(fetchError(data.error));
          }
        })
        .catch(function(error) {
          dispatch(fetchError(error.message));
        });
    };
  },

  onLogin: ({ email, password, hotelCode, myMode, code }) => {
    return dispatch => {
      try {
        console.log('hotelcodex=' + hotelCode);
        console.log('codex=' + code);
        dispatch(fetchStart());
        var myemail = email;
        var mypassword = password;
        var myhotelCode = hotelCode;
        var mycode = '';
        console.log(myMode);
        console.log(myhotelCode);
        console.log(mycode);
        if (myemail === undefined && mypassword == undefined && myhotelCode == undefined) {
          myemail = 'DEMO';
          mypassword = 'DEMO';
          myhotelCode = 'DEMO';
        }
        var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
        if (window.location.hostname === 'gastro.milenij.hr' || myMode == 1)
          pmsUrl = 'https://secure.webbookingpro.com/api/gastro.php';

        axios
          .post(pmsUrl, {
            Action: 'onLogin',
            email: myemail,
            password: mypassword,
            hotelCode: myhotelCode,
            code: code,
          })
          .then(({ data }) => {
            if (data.result == 'true') {
              localStorage.setItem('token', data.token.access_token);
              localStorage.setItem('expiredPassword', false);
              localStorage.setItem('apiKey', data.apiKey);
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token.access_token;

              dispatch(fetchSuccess());

              dispatch(JWTAuth.getAuthUser(true, data.token.access_token, myMode));
              console.log('tu 1' + data.user.language);
            } else {
              if (data.result == 'false' && data.requireMFA == 1) {
                dispatch(setMFA(data.requireMFA));
                dispatch(fetchError('MFA Google Authentification Code required!'));
              } else if (data.result == 'false' && data.expiredPassword == 'true') {
                localStorage.setItem('token', data.token.access_token);
                localStorage.setItem('expiredPassword', true);
                dispatch(fetchSuccess());
                dispatch(JWTAuth.getAuthUser(true, data.token.access_token, myMode));
              } else dispatch(fetchError(data.Message));
            }
          })
          .catch(function(error) {
            //       dispatch(fetchError(error.message));
          });
      } catch (error) {
        // dispatch(fetchError(error.message));
      }
    };
  },
  onLogout: () => {
    return dispatch => {
      dispatch(fetchStart());
      const token = localStorage.getItem('token');
      var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
      /*if (window.location.hostname === 'gastro.milenij.hr' || myMode == 1)
        pmsUrl = 'https://secure.webbookingpro.com/api/gastro.php';*/
      //      alert(pmsUrl);
      if (pmsUrl == 'https://secure.webbookingpro.com/api/pms.php') {
        axios.post('https://secure.webbookingpro.com/index2.php?page=logout');
      }
      axios
        .post('', {
          Action: 'onLogout',
          token: token,
        })
        .then(({ data }) => {
          if (data.result) {
            dispatch(fetchSuccess());
            localStorage.removeItem('token');
            dispatch(setAuthUser(null));
          } else {
            dispatch(fetchError(data.error));
          }
        })
        .catch(function(error) {
          dispatch(fetchError(error.message));
        });
    };
  },

  onLogout2: ({ myMode }) => {
    return dispatch => {
      dispatch(fetchStart());
      var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
      if (window.location.hostname === 'gastro.milenij.hr' || myMode == 1)
        pmsUrl = 'https://secure.webbookingpro.com/api/gastro.php';
      if (pmsUrl == 'https://secure.webbookingpro.com/api/pms.php') {
        axios.post('https://secure.webbookingpro.com/index2.php?page=logout');
      }
      axios
        .post(pmsUrl, {
          Action: 'onLogout',
        })
        .then(({ data }) => {
          if (data.result) {
            dispatch(fetchSuccess());
            localStorage.removeItem('token');
            dispatch(setAuthUser(null));
            if (window.location.hostname === 'gastro.milenij.hr' || myMode == 1) window.location = '/gastromobile';
            else window.location = '/mobile';
          } else {
            dispatch(fetchError(data.error));
          }
        })
        .catch(function(error) {
          dispatch(fetchError(error.message));
        });
    };
  },

  getAuthUser: (loaded = false, token, mode) => {
    return dispatch => {
      if (!token) {
        const token = localStorage.getItem('token');
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

        //        console.log(getState());
      }
      const token = localStorage.getItem('token');
      const selectedId = localStorage.getItem('selectedProperty');

      dispatch(fetchStart());
      dispatch(updateLoadUser(loaded));
      var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
      if (window.location.hostname === 'gastro.milenij.hr' || mode == 1)
        pmsUrl = 'https://secure.webbookingpro.com/api/gastro.php';
      var ftoken = null;

      var isMobile = 0;
      if (window.matchMedia('(pointer: coarse)').matches) isMobile = 1;
      /*if (window.innerWidth < 800) {

        if (/ipad|iphone|ipod|android|ie|blackberry|fennec/.test(navigator.userAgent.toLowerCase())) isMobile = 1;
      }*/
      if (isMobile == 1 && pmsUrl == 'https://secure.webbookingpro.com/api/pms.php' && token != null && token != '') {
        const { Messaging: FirebaseMessaging } = window.WTN.Firebase;
        FirebaseMessaging.getFCMToken({
          callback: function(data) {
            ftoken = data.token;
            if (ftoken != null && ftoken != '')
              axios.post(pmsUrl, { Action: 'registerToken', token: token, ftoken: ftoken });
          },
        });
      }

      axios
        .post(pmsUrl, { Action: 'getAuthUser', token: token, selectedId: selectedId })
        .then(({ data }) => {
          if (data != null && data.newToken != null && data.newToken != '') {
            localStorage.setItem('token', data.newToken);
          }
          if (data.result) {
            if (data.user.hotels != null && data.user.hotels.length == 0) {
              dispatch(fetchError('No property selected with account.'));
              dispatch(updateLoadUser(true));
              return;
            }

            dispatch(fetchSuccess());
            var can_mobile = 1;
            if (data.maintanance != null && data.maintanance == 1) {
              dispatch(fetchError(data.Message));
            }

            if (data.user.clouduser == 1 && data.user.mobile == 0) {
              var a = navigator.userAgent || navigator.vendor || window.opera;
              var mobile =
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
                  a,
                ) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                  a.substr(0, 4),
                );
              if (mobile === true) can_mobile = 0;
            }

            if (can_mobile == 1) {
              //var item = languageData[0];
              //const { locale, setLocale } = useContext(AppContext);
              //console.log(AppContext);
              console.log('tu 2' + data.user.language);
              //console.log(locale.name);
              //  dispatch(setLocale(item));
              console.log('tu 3');
              console.log('set: ' + data.user.clouduser);
              //const { pmsUrl, setPmsUrl } = useContext(AppContext);
              data.user.langid = 0;
              if (data.user.language == 'hr') data.user.langid = 1;

              if (data.user.clouduser == 0) data.user.pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
              if (data.user.clouduser == 1) data.user.pmsUrl = 'https://secure.webbookingpro.com/api/pass.php';
              dispatch(setAuthUser(data.user));
            } else dispatch(setAuthUser(null));
          } else {
            dispatch(updateLoadUser(true));
          }
        })
        .catch(function(error) {
          dispatch(updateLoadUser(true));
        });
    };
  },

  onForgotPassword: ({ email }) => {
    return dispatch => {
      dispatch(fetchStart());
      axios
        .post('', {
          Action: 'onForgetPassword',
          email: email,
        })
        .then(({ data }) => {});

      setTimeout(() => {
        dispatch(setForgetPassMailSent(true));
        dispatch(fetchSuccess());
      }, 300);
    };
  },
  getSocialMediaIcons: () => {
    return <React.Fragment> </React.Fragment>;
  },
};

export default JWTAuth;
